import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import { IconButton, Tooltip } from "@mui/material";

interface IPenEditButton {
    onClick: () => void;
    tooltipText: string;
}

/**
 * Tiny Edit button with a pen icon
 */
const PenEditButton = ({ onClick, tooltipText }: IPenEditButton) => {
    const sx = {
        padding: "4px",
        color: "action.active",
        "&:hover": {
            color: "#000",
            backgroundColor: "action.hover",
        },
    };

    return (
        <Tooltip title={tooltipText} arrow>
            <IconButton onClick={onClick} size="small" sx={sx}>
                <ModeEditOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
        </Tooltip>
    );
};

export default PenEditButton;
